import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import * as _ from 'underscore';

import { Messages } from '../../../codegen/Localize';
import { IServerUserInfo } from '../../../ts/models/IServerUserInfo';
import { Set } from '../../../ts/models/Set';
import { AddUsersOptionsAction } from '../../../ts/services/AddUsersOptionsAction';
import { DeleteUsersFromServerAction } from '../../../ts/services/DeleteUsersFromServerAction';
import { EditSiteMembershipAction } from '../../../ts/services/EditSiteMembershipAction';
import { ForcePasswordUpdateAction } from '../../../ts/services/ForcePasswordUpdateAction';
import { ResetLoginRateLimitingAction } from '../../../ts/services/ResetLoginRateLimitingAction';
import {
  ServerUserAddUsers, ServerUserDelete, ServerUserEditSiteMembership, ServerUserForcePasswordUpdate, ServerUserResetLoginRateLimiting
} from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { ServerUserAddAction, ServerUserMenuAction } from '../../actions/spaces/ServerUserMenuActions';
import { ServiceLocator } from '../../ServiceLocator';
import { reloadSpace } from './content/RefreshContentSagas';

export function addUsers() {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<AddUsersOptionsAction>('AddUsersOptionsAction')
    .showAddServerUsersOptionsDialog(context);
}

export function* handleAddUsers(action: ServerUserAddAction): SagaIterator {
  try {
    yield call(addUsers);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function deleteUsers(users: IServerUserInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<DeleteUsersFromServerAction>('DeleteUsersFromServerAction')
    .showDeleteUsersFromServerDialog(Set.fromIdItemArray(users), context);
}

export function* handleDeleteUsers(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(deleteUsers, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function editSiteMembership(users: IServerUserInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<EditSiteMembershipAction>('EditSiteMembershipAction')
    .showEditSiteMembershipDialog(Set.fromIdItemArray(users), context);
}

export function* handleEditSiteMembership(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(editSiteMembership, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function forcePasswordUpdate(users: IServerUserInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ForcePasswordUpdateAction>('ForcePasswordUpdateAction')
    .onServerUsers(context, Set.fromIdItemArray(users));
}

export function* handleForcePasswordUpdate(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(forcePasswordUpdate, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function resetLoginRateLimiting(users: IServerUserInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ResetLoginRateLimitingAction>('ResetLoginRateLimitingAction')
    .onServerUsers(context, Set.fromIdItemArray(users));
}

export function* handleResetLoginRateLimiting(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(resetLoginRateLimiting, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootServerUserMenuActionSaga(): SagaIterator {
  yield takeEvery(ServerUserAddUsers, handleAddUsers);
  yield takeEvery(ServerUserEditSiteMembership, handleEditSiteMembership);
  yield takeEvery(ServerUserDelete, handleDeleteUsers);
  yield takeEvery(ServerUserForcePasswordUpdate, handleForcePasswordUpdate);
  yield takeEvery(ServerUserResetLoginRateLimiting, handleResetLoginRateLimiting);
}
